import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { IAC } from "../../../../Common/AdviserCharges/Components/IAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesCopyOption } from "./ChargesCopyOption";

interface IAdviserChargesProps extends IProcessComponentProps {}

interface IAdviserChargesState {}

export class AdviserCharges extends ProcessComponent<IAdviserChargesProps, IAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    public render(): JSX.Element {
        return (
            <>
                <h2 className="mb-22">{AdviserChargesContents.AcHeader}</h2>

                <ChargesCopyOption {...this.props} />

                <h3 className="heading-underlined">{AdviserChargesContents.ProductLevel}</h3>

                <IAC type={SubAccountType.StocksIsa} {...this.getProps("IsaModel")} />

                <OAC type={SubAccountType.StocksIsa} {...this.getProps("IsaModel")} />

                <ChargesOnIllustration {...this.getProps("IsaModel")} />
            </>
        );
    }
}
